export default {
  TBD: "...",
  null: "NULL",
  unknown: "UNKNOWN",
};
